<template>
  <div
    class="d-flex-row space-between height-max-content start_selling work_with_us_spacing gap-5 lg-row-to-col gap-lg-48"
  >
    <div class="d-flex-column justify-start align-start flex-5 gap-72">
      <div class="d-flex-column justify-start align-start gap-18">
        <p
          class="regular-s font-family-2 t-orange caps"
          style="letter-spacing: 2.24px"
        >
          {{ $t("work_with_us_2.application_process") }}
        </p>
        <h2
          class="t-white font-family-1 title-h2 f-w-600"
          style="max-width: 15ch"
        >
          {{ $t("work_with_us_2.start_selling_in") }}
        </h2>
      </div>

      <img
        src="/images/work-with-us/start_selling.webp"
        alt="start_selling"
        class="start_selling_image"
      />
    </div>

    <div class="d-flex-column justify-start align-start flex-5 gap-8">
      <div
        class="start_selling_step b-radius-12 d-flex-row justify-start align-start height-max-content gap-32"
        v-for="step in steps"
        :key="step.id"
      >
        <div class="d-flex-column width-max-content gap-12">
          <label class="t-orange font-family-1 regular-xxxxl f-w-600">{{
            step.id
          }}</label>
          <div class="gradient_line" />
        </div>

        <div class="d-flex-column justify-start align-start gap-12">
          <label class="t-white font-family-2 bold-xxxl">{{
            $t(`work_with_us_2.start_selling_steps.${step.title}`)
          }}</label>
          <p class="t-grey font-family-2 regular-l">
            {{ $t(`work_with_us_2.start_selling_steps.${step.description}`) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const steps = ref([
  {
    id: "01",
    title: "first_title",
    description: "first_description",
  },
  {
    id: "02",
    title: "second_title",
    description: "second_description",
  },
  {
    id: "03",
    title: "third_title",
    description: "third_description",
  },
  {
    id: "04",
    title: "fourth_title",
    description: "fourth_description",
  },
  {
    id: "05",
    title: "fifth_title",
    description: "fifth_description",
  },
]);
</script>

<style lang="scss">
.start_selling {
  .start_selling_image {
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
    max-width: 640px;
  }

  .start_selling_step {
    padding: 30px 26px;
    background-color: var(--bg-dark);
  }
  .gradient_line {
    height: 33px;
    width: 1px;
    background: linear-gradient(
      180deg,
      rgba(255, 158, 72, 0.4) 0%,
      rgba(255, 158, 72, 0) 100%
    );
  }
}
</style>
